import Chip from '@mui/material/Chip'
import type { IssuePriority, IssueStatus, ReportStatus, WorkItemStatus } from '../api/execution'

const REPORT: Record<ReportStatus, { label: string; color: string; bg: string }> = {
  DRAFT: { label: 'Draft', color: '#4a5a68', bg: '#e6ebef' },
  SUBMITTED: { label: 'Submitted', color: '#0d4a8a', bg: '#dceaf8' },
  UNDER_REVIEW: { label: 'Under review', color: '#7a4a00', bg: '#fdeecf' },
  APPROVED: { label: 'Approved', color: '#0b5d3b', bg: '#dcf2e6' },
  REJECTED: { label: 'Rejected', color: '#8c1d18', bg: '#fbe0de' },
  REVISED: { label: 'Revised', color: '#5a3e8a', bg: '#eae3f8' },
}

const WORK: Record<WorkItemStatus, { label: string; color: string; bg: string }> = {
  PLANNED: { label: 'Planned', color: '#4a5a68', bg: '#e6ebef' },
  PROCESSING: { label: 'Processing', color: '#0b4a72', bg: '#dceaf6' },
  COMPLETED: { label: 'Completed', color: '#14532d', bg: '#d6f5df' },
  PENDING: { label: 'Pending', color: '#7a4a00', bg: '#fdeecf' },
}

const PRIORITY: Record<IssuePriority, { color: string; bg: string }> = {
  CRITICAL: { color: '#8c1d18', bg: '#fbe0de' },
  HIGH: { color: '#9a4a00', bg: '#fdeecf' },
  MEDIUM: { color: '#0d4a8a', bg: '#dceaf8' },
  LOW: { color: '#4a5a68', bg: '#e6ebef' },
}

const ISSUE: Record<IssueStatus, { label: string; color: string; bg: string }> = {
  OPEN: { label: 'Open', color: '#8c1d18', bg: '#fbe0de' },
  IN_PROGRESS: { label: 'In progress', color: '#7a4a00', bg: '#fdeecf' },
  RESOLVED: { label: 'Resolved', color: '#0b5d3b', bg: '#dcf2e6' },
  CLOSED: { label: 'Closed', color: '#4a5a68', bg: '#e6ebef' },
  DEFERRED: { label: 'Deferred', color: '#5a3e8a', bg: '#eae3f8' },
}

function base(label: string, color: string, bg: string, size: 'small' | 'medium' = 'small') {
  return (
    <Chip
      label={label}
      size={size}
      sx={{ color, backgroundColor: bg, fontWeight: 700, borderRadius: 1 }}
    />
  )
}

export function ReportStatusChip({ status, size }: { status: ReportStatus; size?: 'small' | 'medium' }) {
  const s = REPORT[status] ?? REPORT.DRAFT
  return base(s.label, s.color, s.bg, size)
}

export function WorkStatusChip({ status }: { status: WorkItemStatus }) {
  const s = WORK[status] ?? WORK.PLANNED
  return base(s.label, s.color, s.bg)
}

export function PriorityChip({ priority }: { priority: IssuePriority }) {
  const s = PRIORITY[priority] ?? PRIORITY.MEDIUM
  return base(priority.toLowerCase(), s.color, s.bg)
}

export function IssueStatusChip({ status }: { status: IssueStatus }) {
  const s = ISSUE[status] ?? ISSUE.OPEN
  return base(s.label, s.color, s.bg)
}
